import { render, staticRenderFns } from "./individualCallSplit.vue?vue&type=template&id=ff445b82&scoped=true"
import script from "./individualCallSplit.vue?vue&type=script&lang=js"
export * from "./individualCallSplit.vue?vue&type=script&lang=js"
import style0 from "./individualCallSplit.vue?vue&type=style&index=0&id=ff445b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff445b82",
  null
  
)

export default component.exports